import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import makeStyles from '@material-ui/styles/makeStyles';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AvailableSummary from './AvailableSummary';
import StockMovement from './StockMovement';
import StorageReport from './StorageReport';
import { PageHeader } from '../../components';

const useStyles = makeStyles(theme => ({
    root: props => ({
        // margin: props.isDesktop ? theme.spacing(3) : theme.spacing(1.5)
    }),
    header: {
        marginBottom: theme.spacing(2)
    },
    tabBar: {
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(2)
    },
    panel: {
        // Keep child pages flush with the page container; they bring their
        // own spacing, so we only need a small top gap here.
        marginTop: theme.spacing(1)
    }
}));

const StockOverview = ({ showError, showMessage, history, match, isLine }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });
    const [tabIndex, setTabIndex] = useState(0);

    const childProps = { showError, showMessage, history, match, isLine };

    const renderTab = () => {
        switch (tabIndex) {
            case 0:
                return <AvailableSummary {...childProps} />;
            case 1:
                return <StockMovement {...childProps} />;
            case 2:
                return <StorageReport {...childProps} />;
            default:
                return null;
        }
    };

    return (
        <div className={classes.root}>
                <PageHeader
                    title="Medicines & Feed"
                    subtitle="Available stock, movement to sheds, and storage reports"
                />
                {/* Tabs line up with the tables below (2rem on desktop); on mobile a small gutter so the full-width tabs fit */}
                <div style={{
                    margin: isDesktop ? '1rem 2rem 0' : '8px 8px 0',
                }}>
                <Tabs
                    className='custom-tab'
                    value={tabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={isDesktop ? 'standard' : 'fullWidth'}
                    onChange={(event, newValue) => setTabIndex(newValue)}
                >
                    <Tab label="Available" />
                    <Tab label="Movement" />
                    <Tab label="Report" />
                </Tabs>
                </div>
            <div className={classes.panel}>{renderTab()}</div>
        </div>
    );
};

export default StockOverview;
